import { useBreakpointValue } from '@skin-seoul/design-system';
import type { SelectOption } from './MobileSelect';
import MobileSelect from './MobileSelect';
import DesktopSelect from './DesktopSelect';
interface SelectProps {
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
  title?: string;
  width?: string | number;
  showSelectedValue?: boolean;
}
export const Select = (props: SelectProps) => {
  const isMobile = useBreakpointValue({
    base: true,
    tablet: false
  });
  return isMobile ? <MobileSelect {...props} data-sentry-element="MobileSelect" data-sentry-component="Select" data-sentry-source-file="index.tsx" /> : <DesktopSelect {...props} data-sentry-element="DesktopSelect" data-sentry-component="Select" data-sentry-source-file="index.tsx" />;
};
export default Select;
export type { SelectOption };